@if (details$ | async; as logon) {
  <section class="card__section">
    <div class="card__header">
      <h2>Dados do usuário</h2>
      <span
        class="close-btn material-icons"
        launchLabel="Fechar"
        launchSection="Clique"
        launchSiteSection="PortalDeLogons"
        plAnalyticsButton
        (click)="closeSideNav()"
        >
        close
      </span>
    </div>
    @if (error$ | async) {
      <pl-display-error></pl-display-error>
    } @else {
      <section class="card__section__container">
        @if (logon?.userId) {
          <pl-info-card></pl-info-card>
        }
        @if (logon?.userId) {
          <div class="button-actions">
            @if ((logon?.status === 'PENDING_UPDATE' || logon?.status === 'ACTIVE') && !isManagerUser(logon?.logon)) {
              <seds-outlined-button
                (click)="sidenavManagerService.startBlockUserFlow()"
                [size]="smallButton"
                class="secondary"
                iconName="no_accounts"
                launchLabel="Bloquear"
                launchSection="Clique"
                launchSiteSection="PortalDeLogons"
                plAnalyticsButton
                title="Bloquear"
              ></seds-outlined-button>
            }
            @if (logon?.status !== 'BLOCKED') {
              <seds-outlined-button
                (click)="sidenavManagerService.startResetFlow(logon?.status)"
                [size]="smallButton"
                class="secondary"
                iconName="lock_reset"
                launchLabel="Redefinir senha"
                launchSection="Clique"
                launchSiteSection="PortalDeLogons"
                plAnalyticsButton
                title="Redefinir senha"
              ></seds-outlined-button>
            }
            @if (logon?.status === 'BLOCKED' && canUserSeeUnblockedOption(logon)) {
              <seds-outlined-button
                [size]="smallButton"
                class="secondary"
                iconName="account_circle"
                launchLabel="Desbloquear"
                launchSection="Clique"
                launchSiteSection="PortalDeLogons"
                plAnalyticsButton
                title="Desbloquear"
                (click)="sidenavManagerService.startUnblockUserFlow()"
              ></seds-outlined-button>
            }
            @if (!isManagerUser(logon?.logon)) {
              <seds-outlined-button
                [size]="smallButton"
                class="secondary"
                iconName="delete"
                launchLabel="Excluir"
                launchSection="Clique"
                launchSiteSection="PortalDeLogons"
                plAnalyticsButton
                title="Excluir"
                (click)="sidenavManagerService.startDeleteUser()"
              ></seds-outlined-button>
            }
          </div>
        }
      </section>
      @if (!logon?.userId) {
        <seds-loaders-spinner
          class="card__section__loading"
          [mode]="mode.INDETERMINATE"
        ></seds-loaders-spinner>
      }
    }
  </section>
}

<pl-action-footer>
  <div
    class="action-footer__back"
    (click)="closeSideNav()"
    launchLabel="Voltar"
    launchSection="Clique"
    launchSiteSection="PortalDeLogons"
    plAnalyticsButton
    >
    <span class="material-icons arrow-back">arrow_back_ios</span>
    <span>Voltar</span>
  </div>
  <seds-basic-button
    [hidden]="error$ | async"
    (click)="edit()"
    [disabled]="!(details$ | async)?.userId"
    iconName="edit"
    launchLabel="Editar usuário"
    launchSection="Clique"
    launchSiteSection="PortalDeLogons"
    plAnalyticsButton
    title="Editar usuário"
  ></seds-basic-button>
</pl-action-footer>
